// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3dhMN","left":"InfoRow_left__xR7Gu"};